import { render, staticRenderFns } from "./leaveList.vue?vue&type=template&id=068abf57&scoped=true&"
import script from "./leaveList.vue?vue&type=script&lang=ts&"
export * from "./leaveList.vue?vue&type=script&lang=ts&"
import style0 from "./leaveList.vue?vue&type=style&index=0&id=068abf57&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068abf57",
  null
  
)

export default component.exports